import React, { useState } from "react";
import { TabPane } from "reactstrap";

import { Card, CardBody } from "reactstrap";

const Overview = () => {
  const [activeTab, setActiveTab] = useState("1");

  const tabChange = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  return (
    <React.Fragment>
      <TabPane tabId="1">
      <Card className="overview-content shadow-sm rounded-2xl w-100" style={{ maxWidth: "720px", border: "none", marginTop: "0px" }}>
              <CardBody className="p-4" >
                <h5 className="fs-18 fw-bold mb-3" style={{fontSize: "16px", fontWeight: "400", fontFamily:"poppins" }}>About the Catch</h5>
                <p className="text-muted" style={{fontSize: "14px", fontWeight: "400", fontFamily:"poppins" }}>
                  Experience the ocean’s finest with our Fresh Yellowfin Tuna, straight from the pristine waters of the Indian Ocean. Carefully caught by skilled fishermen using sustainable practices, this premium tuna is known for its rich flavor, tender texture, and versatility in cooking.
                </p>

                <h6 className="fs-16 fw-bold mt-4" style={{fontSize: "16px", fontWeight: "400", fontFamily:"poppins" }}>Freshness Guaranteed</h6>
                <p className="text-muted" style={{fontSize: "14px", fontWeight: "400", fontFamily:"poppins" }}>
                  Our Yellowfin Tuna is delivered directly from the fishing boats to ensure top-notch quality and unbeatable freshness. Each catch undergoes rigorous quality checks to meet the highest standards, ensuring a delightful experience in every bite.
                </p>

                <h6 className="fs-16 fw-bold mt-4" style={{fontSize: "16px", fontWeight: "400", fontFamily:"poppins" }}>Weight and Size</h6>
                <p className="text-muted" style={{fontSize: "14px", fontWeight: "400", fontFamily:"poppins" }}>
                  <ul>
                    <li>Average Weight: 50–120 lbs (22–54 kg)</li>
                    <li>Length: 2.5–4 feet (76–122 cm)</li>
                    <li>Available in whole fish or fillets, cut to your preferred size.</li>
                  </ul>
                </p>

                <h6 className="fs-16 fw-bold mt-4" style={{fontSize: "16px", fontWeight: "400", fontFamily:"poppins" }}>Health Benefits</h6>
                <p className="text-muted" style={{fontSize: "14px", fontWeight: "400", fontFamily:"poppins" }}>
                  Packed with lean protein, Omega-3 fatty acids, and essential vitamins like B6 and B12, Yellowfin Tuna is a powerhouse of nutrition. It supports heart health, brain function, and overall well-being, making it a perfect choice for health-conscious seafood lovers.
                </p>
              </CardBody>
            </Card>
       
      </TabPane>
    </React.Fragment>
  );
};

export default Overview;